import _ from 'lodash';
import { createStructuredSelector, createSelector } from 'reselect';

export const getVideoStream = (state) => state.player.stream;
export const getPlayerStream = (state) => state.player.stream || state.player.streamExternal
export const isLoadingStreamInfo = (state) => state.player.isLoading;

export const getNext = (state) => {
  const stream = getVideoStream(state);
  if (!_.get(stream, 'next')) {
    return null;
  }
  const id = stream.next;
  let next = { id };
  if (state.episode[id]) {
    next = { id, ...state.episode[id] };
  }
  return next;
};

export const getPrev = (state) => {
  const stream = getVideoStream(state);
  if (!_.get(stream, 'prev')) {
    return null;
  }
  const id = stream.prev;
  let prev = { id };
  if (state.episode[id]) {
    prev = { id, ...state.episode[id] };
  }
  return prev;
};

export const getPlayerProperty = (state) => state.player.property;

export const getPlayerStateInfo = createSelector(getPlayerProperty, (player) =>
  _.get(player, 'state', -1)
);

export const getPlayerType = (state) => {
  const { player } = state;
  let result = 'off';
  if (player.stream) {
    if (player.stream.is_tv) {
      result = 'tv';
    } else if (player.stream.is_live) {
      if (player.stream.content_type === 'live_dvr') {
        result = 'live_dvr';
      } else {
        result = 'live';
      }
    } else {
      result = 'vod';
    }
  }
  return result;
};

export const getStreamRestrictionsCode = (state) => {
  const stream = getVideoStream(state);
  // Following absolutely unrelated, what if (not really "if" exactly) pre-roll does not started?
  // const prerollState = getPrerollStateSelector(state);
  // return prerollState === 'ended' ? _.get(stream, 'restrictions.0.code') : ''
  return _.get(stream, 'restrictions.0.code');
};

export const getStreamExternalRestrictionsCode = (state) =>
  _.get(state.player, ['streamExternal', 'restrictions', 0, 'code'], '');

export const getDrmError = (state) => state.player.drmError;

export const getVideoId = (store) => store.player.video_id;

export const getVideoInstances = (store) => store.player.videoInstances;

export const getStreamError = (store) => store.player.streamError;

export const contentTypeInfo = createSelector(getVideoStream, (stream) =>
  _.get(stream, 'content_type')
);

export const shareLinkInfo = createSelector(getVideoStream, (stream) =>
  _.get(stream, 'share_link')
);

export default createStructuredSelector({
  isLoading: isLoadingStreamInfo,
  stream: getVideoStream,
  next: getNext,
  prev: getPrev,
  property: getPlayerProperty,
  type: getPlayerType,
  drmError: getDrmError,
  videoInstances: getVideoInstances,
  videoId: getVideoId,
  streamRestrictionsCode: getStreamRestrictionsCode,
  streamError: getStreamError,
  contentType: contentTypeInfo,
  shareLink: shareLinkInfo,
  getPlayerState: getPlayerStateInfo,
});
